import { OnChangeFn, RowSelectionState } from '@tanstack/react-table';
import { LoanDatatableLoan } from 'features/drilldown/LoanDatatable/__generated__/LoanDatatableLoan';
import { LoanTable } from 'features/drilldown/LoanDatatable/LoanTable';
import { TableQueryParameters } from 'hooks/useTableQueryParams';

import { AssetClass } from '__generated__/globalTypes';

interface SelectedDiligenceTableProps {
  data: LoanDatatableLoan[];
  assetClass: AssetClass;
  selection: {
    selected: RowSelectionState;
    onSelectionChange: OnChangeFn<RowSelectionState>;
  };
  pagination: {
    updateParams: (newParams: Partial<TableQueryParameters<any, any>>) => void;

    queryParams: TableQueryParameters<any, any>;
    totalItems?: number;
  };
}

const SelectLoansForDiligenceTable = ({
  data,
  assetClass,
  selection,
  pagination,
}: SelectedDiligenceTableProps) => {
  return (
    <LoanTable
      data={data}
      strings={{ empty: 'No Loans Found' }}
      sorting={{
        state: pagination.queryParams.sortings,
        onSortingChanged: (newSortings) => {
          pagination.updateParams({ sortings: newSortings });
        },
      }}
      assetClass={assetClass}
      selection={selection}
      pagination={pagination}
      // Do not show the listing (POOL) column for the buyer
      omitColumnIds={['listing']}
      isSelectionInfoIcon={false}
    />
  );
};

export default SelectLoansForDiligenceTable;
